'use strict';

//
// set __webpack_public_path__
//

(function (script_id) {
    const me = document.getElementById(script_id);

    if (!me) {
        console.error(`no <script id="${script_id}"/> found, cannot set __webpack_public_path__!`);
        return;
    }

    const src = me.getAttribute('src');
    __webpack_public_path__ = src.substr(0, src.lastIndexOf("/") + 1);
})('app-bundle');


//
// import polyfills
//

require('babel-polyfill');  // TODO not everything!


//
// styles
//

require('normalize.css');
require('slick-carousel/slick/slick.css');
require('./css/index.scss');


//
// scripts
//

import $ from 'jquery';
import Site from './js';

// make jquery available globally
window.$ = $;
window.jQuery = $;

$(document).ready(function () {
    Site.main();
});



// WEBPACK FOOTER //
// ./site/index.js